import {
	SCROLL_TO_TOP,
	RESET_SCROLL_TO_TOP,
	SCROLL_TO_DIRECTOR_MESSAGE,
	RESET_SCROLL_TO_DIRECTOR_MESSAGE,
	SCROLL_TO_INFORMATION,
	RESET_SCROLL_TO_INFORMATION,
	SCROLL_TO_PROGRAM,
	RESET_SCROLL_TO_PROGRAM,
	SCROLL_TO_DIRECTION,
	RESET_SCROLL_TO_DIRECTION,
	SCROLL_TO_OPINIONS,
	RESET_SCROLL_TO_OPINIONS,
	SCROLL_TO_CONTACT,
	RESET_SCROLL_TO_CONTACT
} from '../constants';

export const scrollToTop = (dispatch, state) => {
	dispatch({ type: SCROLL_TO_TOP, state });
	setTimeout(() => {
		dispatch({ type: RESET_SCROLL_TO_TOP, state });
	}, 1000);
};

export const scrollToDirectorMessage = (dispatch, state) => {
	dispatch({ type: SCROLL_TO_DIRECTOR_MESSAGE, state });
	setTimeout(() => {
		dispatch({ type: RESET_SCROLL_TO_DIRECTOR_MESSAGE, state });
	}, 1000);
};

export const scrollToInformation = (dispatch, state) => {
	dispatch({ type: SCROLL_TO_INFORMATION, state });
	setTimeout(() => {
		dispatch({ type: RESET_SCROLL_TO_INFORMATION, state });
	}, 1000);
};

export const scrollToProgram = (dispatch, state) => {
	dispatch({ type: SCROLL_TO_PROGRAM, state });
	setTimeout(() => {
		dispatch({ type: RESET_SCROLL_TO_PROGRAM, state });
	}, 1000);
};

export const scrollToDirection = (dispatch, state) => {
	dispatch({ type: SCROLL_TO_DIRECTION, state });
	setTimeout(() => {
		dispatch({ type: RESET_SCROLL_TO_DIRECTION, state });
	}, 1000);
};

export const scrollToOpinions = (dispatch, state) => {
	dispatch({ type: SCROLL_TO_OPINIONS, state });
	setTimeout(() => {
		dispatch({ type: RESET_SCROLL_TO_OPINIONS, state });
	}, 1000);
};

export const scrollToContact = (dispatch, state) => {
	dispatch({ type: SCROLL_TO_CONTACT, state });
	setTimeout(() => {
		dispatch({ type: RESET_SCROLL_TO_CONTACT, state });
	}, 1000);
};
